export default __webpack_public_path__ + "static/media/MackenzieSaideman2021_12.2e505320.pdf";